import { COUNTRIES, COUNTRY_NAMES } from '@nv/react-commons/src/Constants'

export const mapCountriesToOptions = (countries: string[]) => {
  return countries.map((country: keyof typeof COUNTRIES) => ({
    value: country,
    text: COUNTRY_NAMES[country.toUpperCase()]
  }))
}
